import { render, staticRenderFns } from "./swiper3.vue?vue&type=template&id=dc3767aa&scoped=true&"
import script from "./swiper3.vue?vue&type=script&lang=js&"
export * from "./swiper3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3767aa",
  null
  
)

export default component.exports